import React, { memo } from 'react'
import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  toRight: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
}))

const ConsentUpdateDetail = ({ isEnglish }) => {
  const classes = useStyles()

  return (
    <div className={classes.toRight}>
      <p>
        <em>
          {isEnglish
            ? `This Privacy Policy was last updated and effective on March 4, 2025`
            : `นโยบายนี้แก้ไขล่าสุดและมีผลใช้บังคับตั้งแต่วันที่  4 มีนาคม 2568`}
        </em>
      </p>
    </div>
  )
}

export default memo(ConsentUpdateDetail)
